<template>
    <el-drawer
        :title="formData.id ? '编辑选项值' : '新增选项值'"
        :visible.sync="visible"
        :wrapperClosable="false"
        size="auto"
        @closed="closed"
    >
        <div class="drawer-content">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" >
                <el-form-item prop="status" label="状态:">
                    <el-select v-model="formData.status">
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="禁用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <template v-if="formData.id">
                	<el-form-item prop="position" label="选项层级位置:">
                		周边/{{formData.styleName}}-{{formData.name}}
                	</el-form-item>
                </template>
                <template v-else>
                	<el-form-item prop="position" label="选项层级位置:">
                		<el-radio-group v-model="position">
                			<el-radio :label="1">新增一级选项</el-radio>
                			<el-radio :label="2">新增二级选项</el-radio>
                		</el-radio-group>
                	</el-form-item>				
                	<el-form-item prop="parentId" label="请选择所属的一级选项:" v-if="position == 2">
                	   <el-select v-model="formData.parentId" :filterable="true" placeholder="请选择所属的一级选项">
                		   <template v-for="item in labelClassificationOptions">
                				<el-option v-for="items in item.childList" :key="items.id" :label="items.name" :value="items.id">
                				   {{items.label}} {{items.name}}
                				</el-option>
                			</template>
                		</el-select>
                	</el-form-item>
                </template>
                <el-form-item prop="name" label="选项值中文:">
                    <el-input v-model="formData.name" placeholder="请填写" size="medium" :maxlength="20"></el-input>
                </el-form-item>
                <el-form-item prop="nameEn" label="选项值英文:">
                    <el-input v-model="formData.nameEn" placeholder="请填写" size="medium" :maxlength="40" ></el-input>
                </el-form-item>
                <el-form-item  label="备注:">
                    <el-input type="textarea" v-model="formData.remark" placeholder="请填写" size="medium" :maxlength="100" ></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="submitLoading">提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import {fetchtagStyleList} from '@/assets/js/commonApi';
export default {
    data() {
        this.defaultFormData = {
            id: null,
            // 状态 | 必填 | 状态，1：启用 2：禁用
            status: 1, 
            // 标签分类 | 必填
            parentId: null,
            // 标签值中文 | 必填 | 长度20
            name: null,
            // 标签值英文 | 必填 | 长度40
            nameEn: null,
            // 备注 | 长度100
            remark: null
        }

        return {
            visible: false,
            formData: {
                ...this.defaultFormData
            },
            rules: {
                status: { required: true, message: "请选择状态", trigger: 'change'},
                parentId: { required: true, message: "请选择标签分类", trigger: 'change'},
                name: { required: true, message: "请填写标签值中文", trigger: 'change'},
                nameEn: { required: true, message: "请填写标签值英文", trigger: 'change'}
            },
            submitLoading: false,
            labelClassificationOptions: [],
			position:1
        };
    },
    created() {
        this.fetchLabelClassification();
    },
    methods: {
        show(data) {
            this.fetchLabelClassification();
            const {tagId: id = null, status = 1, parentId = null, tagName: name = null, tagNameEn: nameEn = null, remark = null ,styleName: styleName =  null,styleNameEn: styleNameEn =  null} = data || {};
            
            this.formData = {id, status, parentId, name, nameEn, remark,styleName,styleNameEn};
            
            this.formData.name = this.formData.name ? this.formData.name : this.formData.styleName
			this.formData.nameEn = this.formData.nameEn ? this.formData.nameEn : this.formData.styleNameEn
            this.visible = true;
        },
        closed() {
            this.formData = {...this.defaultFormData};
            
            this.$nextTick(() => {
                this.$refs['formData'].clearValidate();
            });
        },
        // 获取标签分类
        async fetchLabelClassification() {
            const res = await fetchtagStyleList({
                searchType: 3
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            });

            const { state, msg, result} = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.labelClassificationOptions = (result || [])
            console.log(this.labelClassificationOptions)
        },
        // 表单提交
        submitForm() {
			if( !this.formData.id){
				if( this.position == 1 ){
					this.formData.parentId = this.labelClassificationOptions[0].id
				}
			}
            this.$refs["formData"].validate(async (valid) => {
                if(!valid) {
                    return ;
                }
                const res = await this.$request({
                    url: '/styleTag/tag/save',
                    method: 'post',
                    data: {...this.formData,searchType:3}
                }).catch(() => {
                    return {data: {state: '0', msg: '请求错误'}};
                });

                const { state, msg} = res.data;

                if(state !== '1') {
                    return this.$message.error(msg || '请求失败');
                }
                
                this.visible = false;
                this.$emit('submitSuccess');

            });
        },
    },
};
</script>